export type FeedbackOpen = () => void;
export const feedbackOpenKey = Symbol() as InjectionKey<FeedbackOpen>;
